import PortalLearningPath from '@classes/LearningPath'
import React from 'react'
import { Transition } from 'react-transition-group'
import { ITransitionState } from './interface'
import SliderContent from './SliderContent'
import { SlideIn } from './style'

interface IPRightSlider {
  duration?: number
  isOpen: boolean
  onCloseHandler: (val?: boolean) => void
  Path: PortalLearningPath
  MainPath: PortalLearningPath
}

const RightSlider: React.FC<IPRightSlider> = ({ duration = 400, onCloseHandler, isOpen, Path, MainPath }) => (
  <Transition in={isOpen} timeout={duration}>
    {(state: ITransitionState) => (
      <SlideIn state={state} duration={duration}>
        <SliderContent onCloseHandler={onCloseHandler} isOpen={isOpen} Path={Path} MainPath={MainPath} />
      </SlideIn>
    )}
  </Transition>
)

export default RightSlider
